/**
 * Supplier signal for Kaching Bundles upsells.
 * Writes a cart note + attributes reflecting whether the currently selected
 * bar's upsell (e.g. the paid Funda Transpirable add-on) is included or not,
 * so it's visible on the order for fulfillment/supplier purposes.
 */
(function () {
  function getSelectedBarUpsell() {
    var block = document.querySelector('kaching-bundles-block:not(quick-buy-drawer *)');
    if (!block) return null;

    var barElement = block.querySelector('.kaching-bundles__bar.kaching-bundles__bar--selected');
    var dealBlockRaw = block.getAttribute('deal-block');
    if (!barElement || !dealBlockRaw) return null;

    var dealBlock;
    try {
      dealBlock = JSON.parse(dealBlockRaw);
    } catch (e) {
      return null;
    }

    var barId = barElement.getAttribute('data-deal-bar-id');
    var bar = (dealBlock.dealBars || []).filter(function (b) {
      return b.id === barId;
    })[0];
    if (!bar || !bar.upsells || !bar.upsells.length) return null;

    var upsellConfig = bar.upsells[0];
    var checkboxElement = barElement.querySelector('.kaching-bundles__upsell__checkbox');
    var included = !!checkboxElement && checkboxElement.classList.contains('kaching-bundles__upsell__checkbox--selected');
    var productIdMatch = String(upsellConfig.productGID || '').match(/(\d+)$/);

    return {
      text: upsellConfig.text,
      productId: productIdMatch ? productIdMatch[1] : null,
      included: included
    };
  }

  function updateCart(body) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).catch(function (err) {
      console.error('[kaching-supplier-signal] cart/update.js failed', err);
    });
  }

  // Best-effort, immediate: fires right after the widget's own add-to-cart call succeeds.
  function signalFromWidget() {
    var upsell = getSelectedBarUpsell();
    if (!upsell || !upsell.productId) return;
    updateCart({
      note: (upsell.included ? 'Upsell incluido: ' : 'Upsell NO incluido: ') + upsell.text,
      attributes: {
        supplier_upsell_status: upsell.included ? 'included' : 'excluded',
        supplier_upsell_item: upsell.text,
        supplier_upsell_product_id: upsell.productId
      }
    });
  }

  // Safety net: re-checks actual cart contents against the stored product id.
  // Corrects the signal if the DOM read above happened at the wrong moment,
  // or the customer removed the item afterwards (e.g. from the cart drawer).
  function reconcileFromCart() {
    fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var attrs = cart.attributes || {};
        var productId = attrs.supplier_upsell_product_id;
        if (!productId) return;

        var included = cart.items.some(function (item) {
          return String(item.product_id) === String(productId);
        });
        var newStatus = included ? 'included' : 'excluded';
        if (attrs.supplier_upsell_status === newStatus) return;

        updateCart({
          note: (included ? 'Upsell incluido: ' : 'Upsell NO incluido: ') + (attrs.supplier_upsell_item || ''),
          attributes: { supplier_upsell_status: newStatus }
        });
      })
      .catch(function (err) {
        console.error('[kaching-supplier-signal] reconcile failed', err);
      });
  }

  function handleCartAddSuccess() {
    signalFromWidget();
  }

  var originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isAddToCart = url.indexOf('/cart/add') !== -1;
      var result = originalFetch.apply(this, arguments);
      if (isAddToCart) {
        result.then(function (response) {
          if (response && response.ok) handleCartAddSuccess();
        }).catch(function () {});
      }
      return result;
    };
  }

  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__isAddToCart = typeof url === 'string' && url.indexOf('/cart/add') !== -1;
    return originalOpen.apply(this, arguments);
  };
  var originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__isAddToCart) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) handleCartAddSuccess();
      });
    }
    return originalSend.apply(this, arguments);
  };

  document.documentElement.addEventListener('cart:change', reconcileFromCart);
  document.documentElement.addEventListener('cart:refresh', reconcileFromCart);
  document.addEventListener('DOMContentLoaded', reconcileFromCart);
})();
